import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "../components";
import { useDispatch, useSelector } from "react-redux";
import {
	getPlayers,
	getMatches,
	getTeams,
	getCourts,
} from "../redux/actions/actions";

export default function Player() {
	const { id } = useParams();
	const dispatch = useDispatch();
	const players = useSelector((state) => state.players);
	const [player, setPlayer] = useState(
		players && players.find((player) => player.id === id)
	);
	const theme = useSelector((state) => state.theme);
	const matches = useSelector((state) => state.endedMatches);
	const teams = useSelector((state) => state.teams);
	const courts = useSelector((state) => state.courts);
	const [section, setSection] = useState("profile");
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (players.length === 0) dispatch(getPlayers());
		if (matches.length === 0) dispatch(getMatches());
		if (teams.length === 0) dispatch(getTeams());
		if (courts.length === 0) dispatch(getCourts());
	}, [dispatch, players, matches, teams, courts]);

	useEffect(() => {
		if (
			players.length > 0 &&
			matches.length > 0 &&
			teams.length > 0 &&
			courts.length > 0
		) {
			setLoading(false);
		}
	}, [players, matches, teams, courts]);

	useEffect(() => {
		setPlayer(players.find((player) => player.id === id));
	}, [players, id]);

	useEffect(() => {
		// scroll to top
		window.scrollTo(0, 0);
	}, [section]);

	return (
		<div
			className={`flex flex-col max-lg:gap-3 gap-6 mt-2 items-center justify-center`}
		>
			{loading ? (
				<div className={`flex justify-center items-center h-[60svh]`}>
					<Loader className={`w-10`} />
				</div>
			) : (
				<div className={`w-full max-w-[800px] px-2`}>
					{matches && teams && player && (
						<div className={`flex flex-col items-center justify-center`}>
							<div
								className={`flex flex-row items-end justify-between w-full border-b-2 border-${theme}-secondaryColor pb-2 max-lg:items-start`}
							>
								<div className={`flex flex-row items-center justify-center`}>
									<p
										className={`text-${theme}-primaryColor text-5xl font-gothamBold max-lg:text-3xl`}
									>
										#{player?.ranking_position}
									</p>
									<div className={`flex flex-col items-start`}>
										<p
											className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-xs`}
										>
											RANKING
										</p>
										<p
											className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-xs -mt-3 max-lg:-mt-1`}
										>
											GLOBAL
										</p>
									</div>
								</div>
								<div className={`flex flex-col items-center justify-center`}>
									<img
										src={player?.avatar}
										alt={player?.name}
										className={`w-64 h-64 object-cover max-lg:w-28 max-lg:h-28 rounded-full border-2 border-${theme}-primaryColor`}
									/>
									<h1
										className={`text-${theme}-primaryColor font-gothamBold text-2xl mt-2 uppercase max-lg:text-sm`}
									>
										{player?.name}
									</h1>
								</div>

								<div className={`flex flex-row items-center justify-center`}>
									<p
										className={`text-${theme}-primaryColor text-5xl font-gothamBold max-lg:text-3xl`}
									>
										{player?.ranking_position_singles === 0
											? "N/A"
											: `#` + player?.ranking_position_singles}
									</p>
									<div className={`flex flex-col items-start`}>
										<p
											className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-xs`}
										>
											RANKING
										</p>
										<p
											className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-xs -mt-3 max-lg:-mt-1`}
										>
											SINGLES
										</p>
									</div>
								</div>
							</div>
							<div
								className={`flex flex-row justify-center items-center w-full pt-2 gap-4 border-b-2 border-gray-200`}
							>
								<p
									className={
										`
										"text-${theme}-primaryColor cursor-pointer text-base font-semibold max-lg:text-[14px] ` +
										(section === "profile"
											? `border-b-2 border-${theme}-secondaryColor`
											: `border-b-2 border-transparent`)
									}
									onClick={() => setSection("profile")}
								>
									PERFIL
								</p>
								<div
									className={`border-l-2 border-${theme}-primaryColor h-4 max-lg:h-3`}
								></div>

								<p
									className={
										`text-${theme}-primaryColor cursor-pointer text-base font-semibold max-lg:text-[14px] ` +
										(section === "stats"
											? `border-b-2 border-${theme}-secondaryColor`
											: `border-b-2 border-transparent`)
									}
									onClick={() => setSection("stats")}
								>
									ESTADÍSTICAS
								</p>
								<div
									className={`border-l-2 border-${theme}-primaryColor h-4 max-lg:h-3`}
								></div>
								<p
									className={
										`text-${theme}-primaryColor cursor-pointer text-base font-semibold max-lg:text-[14px] ` +
										(section === "history"
											? `border-b-2 border-${theme}-secondaryColor`
											: `border-b-2 border-transparent`)
									}
									onClick={() => setSection("history")}
								>
									HISTORIALES
								</p>
							</div>
							<div
								className={`flex flex-col items-center justify-center w-full`}
							>
								{section === "profile" && (
									<div
										className={`flex flex-col items-center justify-center w-full`}
									>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Género
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{player?.gender === "male" ? "Hombre" : "Mujer"}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Edad
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{Math.floor(
													(new Date() - new Date(player?.birth_date)) /
														31556952000
												).toFixed(0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Fecha de nacimiento
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{new Date(player?.birth_date).toLocaleDateString()}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Nacionalidad
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												Argentina
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Altura
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{player?.height / 100} mts
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Mano dominante
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{player?.preferred_hand === "right"
													? "Derecha"
													: "Izquierda"}
											</p>
										</div>
									</div>
								)}
								{section === "stats" && (
									<div
										className={`flex flex-col items-center justify-center w-full`}
									>
										<p
											className={`self-start text-${theme}-primaryColor text-lg max-lg:text-sm mt-2 font-gothamBold uppercase`}
										>
											Partidos totales
										</p>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm`}
											>
												Partidos jugados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm`}
											>
												{
													matches.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													).length
												}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Partidos ganados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{
													matches
														.filter(
															(match) =>
																match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id ||
																match.team_2.player_1?.id === player?.id ||
																match.team_2.player_2?.id === player?.id
														)
														.filter(
															(match) =>
																match.winner_team?.player_1_id === player?.id ||
																match.winner_team?.player_2_id === player?.id
														).length
												}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Partidos perdidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{
													matches
														.filter(
															(match) =>
																match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id ||
																match.team_2.player_1?.id === player?.id ||
																match.team_2.player_2?.id === player?.id
														)
														.filter(
															(match) =>
																match.winner_team?.player_1_id !== player?.id &&
																match.winner_team?.player_2_id !== player?.id
														).length
												}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Efectividad de partidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{isNaN(
													(
														(
															matches
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.filter(
																	(match) =>
																		match.winner_team?.player_1_id ===
																			player?.id ||
																		match.winner_team?.player_2_id ===
																			player?.id
																).length /
															matches.filter(
																(match) =>
																	match.team_1.player_1?.id === player?.id ||
																	match.team_1.player_2?.id === player?.id ||
																	match.team_2.player_1?.id === player?.id ||
																	match.team_2.player_2?.id === player?.id
															).length
														).toFixed(2) * 100
													).toFixed(0)
												)
													? 0
													: (
															(
																matches
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.filter(
																		(match) =>
																			match.winner_team?.player_1_id ===
																				player?.id ||
																			match.winner_team?.player_2_id ===
																				player?.id
																	).length /
																matches.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																).length
															).toFixed(2) * 100
													  ).toFixed(0)}
												%
											</p>
										</div>
										<hr className={`w-full border-gray-200 mt-2`} />
										<p
											className={`self-start text-${theme}-primaryColor text-lg max-lg:text-sm mt-2 font-gothamBold uppercase`}
										>
											PARTIDOS DE SINGLES
										</p>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm`}
											>
												Partidos jugados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm`}
											>
												{
													matches
														.filter((match) => match.category === "singles")
														.filter(
															(match) =>
																match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id ||
																match.team_2.player_1?.id === player?.id ||
																match.team_2.player_2?.id === player?.id
														).length
												}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Partidos ganados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{
													matches
														.filter((match) => match.category === "singles")
														.filter(
															(match) =>
																match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id ||
																match.team_2.player_1?.id === player?.id ||
																match.team_2.player_2?.id === player?.id
														)
														.filter(
															(match) =>
																match.winner_team?.player_1_id === player?.id ||
																match.winner_team?.player_2_id === player?.id
														).length
												}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Partidos perdidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{
													matches
														.filter((match) => match.category === "singles")
														.filter(
															(match) =>
																match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id ||
																match.team_2.player_1?.id === player?.id ||
																match.team_2.player_2?.id === player?.id
														)
														.filter(
															(match) =>
																match.winner_team?.player_1_id !== player?.id &&
																match.winner_team?.player_2_id !== player?.id
														).length
												}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Efectividad de partidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{isNaN(
													(
														(
															(matches
																.filter((match) => match.category === "singles")
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.filter(
																	(match) =>
																		match.winner_team?.player_1_id ===
																			player?.id ||
																		match.winner_team?.player_2_id ===
																			player?.id
																).length || 0) /
															(matches
																.filter((match) => match.category === "singles")
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																).length || 0)
														).toFixed(2) * 100
													).toFixed(0)
												)
													? 0
													: (
															(
																(matches
																	.filter(
																		(match) => match.category === "singles"
																	)
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.filter(
																		(match) =>
																			match.winner_team?.player_1_id ===
																				player?.id ||
																			match.winner_team?.player_2_id ===
																				player?.id
																	).length || 0) /
																(matches
																	.filter(
																		(match) => match.category === "singles"
																	)
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	).length || 0)
															).toFixed(2) * 100
													  ).toFixed(0)}
												%
											</p>
										</div>
										<hr className={`w-full border-gray-200 mt-2`} />
										<p
											className={`self-start text-${theme}-primaryColor text-lg max-lg:text-sm mt-2 font-gothamBold uppercase`}
										>
											PARTIDOS DE DOBLES
										</p>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm`}
											>
												Partidos jugados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm`}
											>
												{
													matches
														.filter((match) => match.category === "doubles")
														.filter(
															(match) =>
																match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id ||
																match.team_2.player_1?.id === player?.id ||
																match.team_2.player_2?.id === player?.id
														).length
												}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Partidos ganados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{
													matches
														.filter((match) => match.category === "doubles")
														.filter(
															(match) =>
																match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id ||
																match.team_2.player_1?.id === player?.id ||
																match.team_2.player_2?.id === player?.id
														)
														.filter(
															(match) =>
																match.winner_team?.player_1_id === player?.id ||
																match.winner_team?.player_2_id === player?.id
														).length
												}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Partidos perdidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{
													matches
														.filter((match) => match.category === "doubles")
														.filter(
															(match) =>
																match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id ||
																match.team_2.player_1?.id === player?.id ||
																match.team_2.player_2?.id === player?.id
														)
														.filter(
															(match) =>
																match.winner_team?.player_1_id !== player?.id &&
																match.winner_team?.player_2_id !== player?.id
														).length
												}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Efectividad de partidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{isNaN(
													(
														(
															(matches
																.filter((match) => match.category === "doubles")
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.filter(
																	(match) =>
																		match.winner_team?.player_1_id ===
																			player?.id ||
																		match.winner_team?.player_2_id ===
																			player?.id
																).length || 0) /
															(matches
																.filter((match) => match.category === "doubles")
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																).length || 0)
														).toFixed(2) * 100
													).toFixed(0)
												)
													? 0
													: (
															(
																(matches
																	.filter(
																		(match) => match.category === "doubles"
																	)
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.filter(
																		(match) =>
																			match.winner_team?.player_1_id ===
																				player?.id ||
																			match.winner_team?.player_2_id ===
																				player?.id
																	).length || 0) /
																(matches
																	.filter(
																		(match) => match.category === "doubles"
																	)
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	).length || 0)
															).toFixed(2) * 100
													  ).toFixed(0)}
												%
											</p>
										</div>

										<hr className={`w-full border-gray-200 mt-2`} />
										<p
											className={`self-start text-${theme}-primaryColor text-lg max-lg:text-sm mt-2 font-gothamBold uppercase`}
										>
											SETS
										</p>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm`}
											>
												Sets jugados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return score.games_team_1 !== 0 ||
																score.games_team_2 !== 0
																? 1
																: 0;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Sets ganados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id
																? score.games_team_1 > score.games_team_2
																	? 1
																	: 0
																: score.games_team_1 < score.games_team_2
																? 1
																: 0;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Sets perdidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id
																? score.games_team_1 < score.games_team_2
																	? 1
																	: 0
																: score.games_team_1 > score.games_team_2
																? 1
																: 0;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Efectividad de sets
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{isNaN(
													(
														(
															matches
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.map((match) => {
																	return Object.values(match.scores).map(
																		(score) => {
																			return match.team_1.player_1?.id ===
																				player?.id ||
																				match.team_1.player_2?.id === player?.id
																				? score.games_team_1 >
																				  score.games_team_2
																					? 1
																					: 0
																				: score.games_team_1 <
																				  score.games_team_2
																				? 1
																				: 0;
																		}
																	);
																})
																.flat()
																.reduce((acc, curr) => acc + curr, 0) /
															matches
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.map((match) => {
																	return Object.values(match.scores).map(
																		(score) => {
																			return score.games_team_1 !== 0 ||
																				score.games_team_2 !== 0
																				? 1
																				: 0;
																		}
																	);
																})
																.flat()
																.reduce((acc, curr) => acc + curr, 0)
														).toFixed(2) * 100
													).toFixed(0)
												)
													? 0
													: (
															(
																matches
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.map((match) => {
																		return Object.values(match.scores).map(
																			(score) => {
																				return match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id
																					? score.games_team_1 >
																					  score.games_team_2
																						? 1
																						: 0
																					: score.games_team_1 <
																					  score.games_team_2
																					? 1
																					: 0;
																			}
																		);
																	})
																	.flat()
																	.reduce((acc, curr) => acc + curr, 0) /
																matches
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.map((match) => {
																		return Object.values(match.scores).map(
																			(score) => {
																				return match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id
																					? score.games_team_1 !== 0 ||
																					  score.games_team_2 !== 0
																						? 1
																						: 0
																					: score.games_team_1 !== 0 ||
																					  score.games_team_2 !== 0
																					? 1
																					: 0;
																			}
																		);
																	})
																	.flat()
																	.reduce((acc, curr) => acc + curr, 0)
															).toFixed(2) * 100
													  ).toFixed(0)}
												%
											</p>
										</div>
										<hr className={`w-full border-gray-200 mt-2`} />
										<p
											className={`self-start text-${theme}-primaryColor text-lg max-lg:text-sm mt-2 font-gothamBold uppercase`}
										>
											GAMES
										</p>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm`}
											>
												Games jugados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return score.games_team_1 + score.games_team_2;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Games ganados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id
																? score.games_team_1
																: score.games_team_2;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Games perdidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id
																? score.games_team_2
																: score.games_team_1;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Efectividad de games
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{isNaN(
													(
														(
															matches
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.map((match) => {
																	return Object.values(match.scores).map(
																		(score) => {
																			return match.team_1.player_1?.id ===
																				player?.id ||
																				match.team_1.player_2?.id === player?.id
																				? score.games_team_1
																				: score.games_team_2;
																		}
																	);
																})
																.flat()
																.reduce((acc, curr) => acc + curr, 0) /
															matches
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.map((match) => {
																	return Object.values(match.scores).map(
																		(score) => {
																			return (
																				score.games_team_1 + score.games_team_2
																			);
																		}
																	);
																})
																.flat()
																.reduce((acc, curr) => acc + curr, 0)
														).toFixed(2) * 100
													).toFixed(0)
												)
													? 0
													: (
															(
																matches
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.map((match) => {
																		return Object.values(match.scores).map(
																			(score) => {
																				return match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id
																					? score.games_team_1
																					: score.games_team_2;
																			}
																		);
																	})
																	.flat()
																	.reduce((acc, curr) => acc + curr, 0) /
																matches
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.map((match) => {
																		return Object.values(match.scores).map(
																			(score) => {
																				return (
																					score.games_team_1 +
																					score.games_team_2
																				);
																			}
																		);
																	})
																	.flat()
																	.reduce((acc, curr) => acc + curr, 0)
															).toFixed(2) * 100
													  ).toFixed(0)}
												%
											</p>
										</div>

										<hr className={`w-full border-gray-200 mt-2`} />
										<p
											className={`self-start text-${theme}-primaryColor text-lg max-lg:text-sm mt-2 font-gothamBold uppercase`}
										>
											TIEBREAKS
										</p>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm`}
											>
												Tiebreaks jugados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return score.tiebreak ? 1 : 0;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Tiebreaks ganados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id
																? score.tiebreak_team_1 > score.tiebreak_team_2
																	? 1
																	: 0
																: score.tiebreak_team_1 < score.tiebreak_team_2
																? 1
																: 0;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Tiebreaks perdidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id
																? score.tiebreak_team_1 < score.tiebreak_team_2
																	? 1
																	: 0
																: score.tiebreak_team_1 > score.tiebreak_team_2
																? 1
																: 0;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Efectividad de tiebreaks
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{isNaN(
													(
														(
															matches
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.map((match) => {
																	return Object.values(match.scores).map(
																		(score) => {
																			return match.team_1.player_1?.id ===
																				player?.id ||
																				match.team_1.player_2?.id === player?.id
																				? score.tiebreak_team_1 >
																				  score.tiebreak_team_2
																					? 1
																					: 0
																				: score.tiebreak_team_1 <
																				  score.tiebreak_team_2
																				? 1
																				: 0;
																		}
																	);
																})
																.flat()
																.reduce((acc, curr) => acc + curr, 0) /
															matches
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.map((match) => {
																	return Object.values(match.scores).map(
																		(score) => {
																			return match.team_1.player_1?.id ===
																				player?.id ||
																				match.team_1.player_2?.id === player?.id
																				? score.tiebreak
																					? 1
																					: 0
																				: score.tiebreak
																				? 1
																				: 0;
																		}
																	);
																})
																.flat()
																.reduce((acc, curr) => acc + curr, 0)
														).toFixed(2) * 100
													).toFixed(0)
												)
													? 0
													: (
															(
																matches
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.map((match) => {
																		return Object.values(match.scores).map(
																			(score) => {
																				return match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id
																					? score.tiebreak_team_1 >
																					  score.tiebreak_team_2
																						? 1
																						: 0
																					: score.tiebreak_team_1 <
																					  score.tiebreak_team_2
																					? 1
																					: 0;
																			}
																		);
																	})
																	.flat()
																	.reduce((acc, curr) => acc + curr, 0) /
																matches
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.map((match) => {
																		return Object.values(match.scores).map(
																			(score) => {
																				return match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id
																					? score.tiebreak
																						? 1
																						: 0
																					: score.tiebreak
																					? 1
																					: 0;
																			}
																		);
																	})
																	.flat()
																	.reduce((acc, curr) => acc + curr, 0)
															).toFixed(2) * 100
													  ).toFixed(0)}
												%
											</p>
										</div>
										<hr className={`w-full border-gray-200 mt-2`} />
										<p
											className={`self-start text-${theme}-primaryColor text-lg max-lg:text-sm mt-2 font-gothamBold uppercase`}
										>
											PUNTOS DE TIEBREAKS
										</p>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm `}
											>
												Puntos de tiebreaks jugados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm `}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return (
																score.tiebreak_team_1 + score.tiebreak_team_2
															);
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Puntos de tiebreaks ganados
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id
																? score.tiebreak_team_1
																: score.tiebreak_team_2;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>
										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Puntos de tiebreaks perdidos
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{matches
													.filter(
														(match) =>
															match.team_1.player_1?.id === player?.id ||
															match.team_1.player_2?.id === player?.id ||
															match.team_2.player_1?.id === player?.id ||
															match.team_2.player_2?.id === player?.id
													)
													.map((match) => {
														return Object.values(match.scores).map((score) => {
															return match.team_1.player_1?.id === player?.id ||
																match.team_1.player_2?.id === player?.id
																? score.tiebreak_team_2
																: score.tiebreak_team_1;
														});
													})
													.flat()
													.reduce((acc, curr) => acc + curr, 0)}
											</p>
										</div>

										<div
											className={`flex flex-row items-center justify-between w-full`}
										>
											<p
												className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
											>
												Efectividad de puntos de tiebreaks
											</p>
											<p
												className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
											>
												{isNaN(
													(
														(
															matches
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.map((match) => {
																	return Object.values(match.scores).map(
																		(score) => {
																			return match.team_1.player_1?.id ===
																				player?.id ||
																				match.team_1.player_2?.id === player?.id
																				? score.tiebreak_team_1
																				: score.tiebreak_team_2;
																		}
																	);
																})
																.flat()
																.reduce((acc, curr) => acc + curr, 0) /
															matches
																.filter(
																	(match) =>
																		match.team_1.player_1?.id === player?.id ||
																		match.team_1.player_2?.id === player?.id ||
																		match.team_2.player_1?.id === player?.id ||
																		match.team_2.player_2?.id === player?.id
																)
																.map((match) => {
																	return Object.values(match.scores).map(
																		(score) => {
																			return (
																				score.tiebreak_team_1 +
																				score.tiebreak_team_2
																			);
																		}
																	);
																})
																.flat()
																.reduce((acc, curr) => acc + curr, 0)
														).toFixed(2) * 100
													).toFixed(0)
												)
													? 0
													: (
															(
																matches
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.map((match) => {
																		return Object.values(match.scores).map(
																			(score) => {
																				return match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id
																					? score.tiebreak_team_1
																					: score.tiebreak_team_2;
																			}
																		);
																	})
																	.flat()
																	.reduce((acc, curr) => acc + curr, 0) /
																matches
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.map((match) => {
																		return Object.values(match.scores).map(
																			(score) => {
																				return (
																					score.tiebreak_team_1 +
																					score.tiebreak_team_2
																				);
																			}
																		);
																	})
																	.flat()
																	.reduce((acc, curr) => acc + curr, 0)
															).toFixed(2) * 100
													  ).toFixed(0)}
												%
											</p>
										</div>
										{courts.map((court) => {
											return (
												<div key={court.id} className={`w-full`}>
													<hr className={`w-full border-gray-200 mt-2`} />
													<p
														className={`self-start text-${theme}-primaryColor text-lg max-lg:text-sm mt-2 font-gothamBold uppercase`}
													>
														Partidos en {court.name}
													</p>
													<div
														className={`flex flex-row items-center justify-between w-full`}
													>
														<p
															className={`text-${theme}-primaryColor text-lg max-lg:text-sm`}
														>
															Partidos jugados
														</p>
														<p
															className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm`}
														>
															{
																matches
																	.filter(
																		(match) => match.court_id === court.id
																	)
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	).length
															}
														</p>
													</div>
													<div
														className={`flex flex-row items-center justify-between w-full`}
													>
														<p
															className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
														>
															Partidos ganados
														</p>
														<p
															className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
														>
															{
																matches
																	.filter(
																		(match) => match.court_id === court.id
																	)
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.filter(
																		(match) =>
																			match.winner_team?.player_1_id ===
																				player?.id ||
																			match.winner_team?.player_2_id ===
																				player?.id
																	).length
															}
														</p>
													</div>
													<div
														className={`flex flex-row items-center justify-between w-full`}
													>
														<p
															className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
														>
															Partidos perdidos
														</p>
														<p
															className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
														>
															{
																matches
																	.filter(
																		(match) => match.court_id === court.id
																	)
																	.filter(
																		(match) =>
																			match.team_1.player_1?.id ===
																				player?.id ||
																			match.team_1.player_2?.id ===
																				player?.id ||
																			match.team_2.player_1?.id ===
																				player?.id ||
																			match.team_2.player_2?.id === player?.id
																	)
																	.filter(
																		(match) =>
																			match.winner_team?.player_1_id !==
																				player?.id &&
																			match.winner_team?.player_2_id !==
																				player?.id
																	).length
															}
														</p>
													</div>
													<div
														className={`flex flex-row items-center justify-between w-full`}
													>
														<p
															className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
														>
															Efectividad de partidos
														</p>
														<p
															className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
														>
															{isNaN(
																(
																	(
																		(matches
																			.filter(
																				(match) => match.court_id === court.id
																			)
																			.filter(
																				(match) =>
																					match.team_1.player_1?.id ===
																						player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id
																			)
																			.filter(
																				(match) =>
																					match.winner_team?.player_1_id ===
																						player?.id ||
																					match.winner_team?.player_2_id ===
																						player?.id
																			).length || 0) /
																		(matches
																			.filter(
																				(match) => match.court_id === court.id
																			)
																			.filter(
																				(match) =>
																					match.team_1.player_1?.id ===
																						player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id
																			).length || 0)
																	).toFixed(2) * 100
																).toFixed(0)
															)
																? 0
																: (
																		(
																			(matches
																				.filter(
																					(match) => match.court_id === court.id
																				)
																				.filter(
																					(match) =>
																						match.team_1.player_1?.id ===
																							player?.id ||
																						match.team_1.player_2?.id ===
																							player?.id ||
																						match.team_2.player_1?.id ===
																							player?.id ||
																						match.team_2.player_2?.id ===
																							player?.id
																				)
																				.filter(
																					(match) =>
																						match.winner_team?.player_1_id ===
																							player?.id ||
																						match.winner_team?.player_2_id ===
																							player?.id
																				).length || 0) /
																			(matches
																				.filter(
																					(match) => match.court_id === court.id
																				)
																				.filter(
																					(match) =>
																						match.team_1.player_1?.id ===
																							player?.id ||
																						match.team_1.player_2?.id ===
																							player?.id ||
																						match.team_2.player_1?.id ===
																							player?.id ||
																						match.team_2.player_2?.id ===
																							player?.id
																				).length || 0)
																		).toFixed(2) * 100
																  ).toFixed(0)}
															%
														</p>
													</div>
												</div>
											);
										})}
									</div>
								)}
								{section === "history" && (
									<div
										className={`flex flex-col items-center justify-center w-full`}
									>
										{players
											.filter((p) => p.id !== player?.id)
											.map((p, index) => {
												return (
													<div className={`w-full`} key={p.id}>
														{index !== 0 && (
															<hr className={`w-full border-gray-200 mt-2`} />
														)}
														<p
															className={`self-start text-${theme}-primaryColor text-lg max-lg:text-sm mt-2 font-gothamBold uppercase`}
														>
															HISTORIAL CONTRA {p.name}
														</p>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm`}
															>
																Partidos jugados totales
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm`}
															>
																{
																	matches
																		.filter(
																			(match) =>
																				(match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id) &&
																				(match.team_1.player_1?.id === p.id ||
																					match.team_1.player_2?.id === p.id ||
																					match.team_2.player_1?.id === p.id ||
																					match.team_2.player_2?.id === p.id)
																		)
																		.filter((match) =>
																			match.team_1.player_1?.id === player?.id
																				? match.team_1.player_2?.id !== p.id
																				: match.team_1.player_2?.id ===
																				  player?.id
																				? match.team_1.player_1?.id !== p.id
																				: match.team_2.player_1?.id ===
																				  player?.id
																				? match.team_2.player_2?.id !== p.id
																				: match.team_2.player_2?.id ===
																				  player?.id
																				? match.team_2.player_1?.id !== p.id
																				: false
																		).length
																}
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Partidos ganados totales
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{
																	matches
																		.filter(
																			(match) =>
																				(match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id) &&
																				(match.team_1.player_1?.id === p.id ||
																					match.team_1.player_2?.id === p.id ||
																					match.team_2.player_1?.id === p.id ||
																					match.team_2.player_2?.id === p.id)
																		)
																		.filter((match) =>
																			match.team_1.player_1?.id === player?.id
																				? match.team_1.player_2?.id !== p.id
																				: match.team_1.player_2?.id ===
																				  player?.id
																				? match.team_1.player_1?.id !== p.id
																				: match.team_2.player_1?.id ===
																				  player?.id
																				? match.team_2.player_2?.id !== p.id
																				: match.team_2.player_2?.id ===
																				  player?.id
																				? match.team_2.player_1?.id !== p.id
																				: false
																		)
																		.filter(
																			(match) =>
																				match.winner_team?.player_1_id ===
																					player?.id ||
																				match.winner_team?.player_2_id ===
																					player?.id
																		).length
																}
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Partidos perdidos totales
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{
																	matches
																		.filter(
																			(match) =>
																				(match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id) &&
																				(match.team_1.player_1?.id === p.id ||
																					match.team_1.player_2?.id === p.id ||
																					match.team_2.player_1?.id === p.id ||
																					match.team_2.player_2?.id === p.id)
																		)
																		.filter((match) =>
																			match.team_1.player_1?.id === player?.id
																				? match.team_1.player_2?.id !== p.id
																				: match.team_1.player_2?.id ===
																				  player?.id
																				? match.team_1.player_1?.id !== p.id
																				: match.team_2.player_1?.id ===
																				  player?.id
																				? match.team_2.player_2?.id !== p.id
																				: match.team_2.player_2?.id ===
																				  player?.id
																				? match.team_2.player_1?.id !== p.id
																				: false
																		)
																		.filter(
																			(match) =>
																				match.winner_team?.player_1_id !==
																					player?.id &&
																				match.winner_team?.player_2_id !==
																					player?.id
																		).length
																}
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Efectividad de partidos totales
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{isNaN(
																	(
																		(
																			(matches
																				.filter(
																					(match) =>
																						(match.team_1.player_1?.id ===
																							player?.id ||
																							match.team_1.player_2?.id ===
																								player?.id ||
																							match.team_2.player_1?.id ===
																								player?.id ||
																							match.team_2.player_2?.id ===
																								player?.id) &&
																						(match.team_1.player_1?.id ===
																							p.id ||
																							match.team_1.player_2?.id ===
																								p.id ||
																							match.team_2.player_1?.id ===
																								p.id ||
																							match.team_2.player_2?.id ===
																								p.id)
																				)
																				.filter((match) =>
																					match.team_1.player_1?.id ===
																					player?.id
																						? match.team_1.player_2?.id !== p.id
																						: match.team_1.player_2?.id ===
																						  player?.id
																						? match.team_1.player_1?.id !== p.id
																						: match.team_2.player_1?.id ===
																						  player?.id
																						? match.team_2.player_2?.id !== p.id
																						: match.team_2.player_2?.id ===
																						  player?.id
																						? match.team_2.player_1?.id !== p.id
																						: false
																				)
																				.filter(
																					(match) =>
																						match.winner_team?.player_1_id ===
																							player?.id ||
																						match.winner_team?.player_2_id ===
																							player?.id
																				).length || 0) /
																			(matches
																				.filter(
																					(match) =>
																						(match.team_1.player_1?.id ===
																							player?.id ||
																							match.team_1.player_2?.id ===
																								player?.id ||
																							match.team_2.player_1?.id ===
																								player?.id ||
																							match.team_2.player_2?.id ===
																								player?.id) &&
																						(match.team_1.player_1?.id ===
																							p.id ||
																							match.team_1.player_2?.id ===
																								p.id ||
																							match.team_2.player_1?.id ===
																								p.id ||
																							match.team_2.player_2?.id ===
																								p.id)
																				)
																				.filter((match) =>
																					match.team_1.player_1?.id ===
																					player?.id
																						? match.team_1.player_2?.id !== p.id
																						: match.team_1.player_2?.id ===
																						  player?.id
																						? match.team_1.player_1?.id !== p.id
																						: match.team_2.player_1?.id ===
																						  player?.id
																						? match.team_2.player_2?.id !== p.id
																						: match.team_2.player_2?.id ===
																						  player?.id
																						? match.team_2.player_1?.id !== p.id
																						: false
																				).length || 0)
																		).toFixed(2) * 100
																	).toFixed(0)
																)
																	? 0
																	: (
																			(
																				(matches
																					.filter(
																						(match) =>
																							(match.team_1.player_1?.id ===
																								player?.id ||
																								match.team_1.player_2?.id ===
																									player?.id ||
																								match.team_2.player_1?.id ===
																									player?.id ||
																								match.team_2.player_2?.id ===
																									player?.id) &&
																							(match.team_1.player_1?.id ===
																								p.id ||
																								match.team_1.player_2?.id ===
																									p.id ||
																								match.team_2.player_1?.id ===
																									p.id ||
																								match.team_2.player_2?.id ===
																									p.id)
																					)
																					.filter((match) =>
																						match.team_1.player_1?.id ===
																						player?.id
																							? match.team_1.player_2?.id !==
																							  p.id
																							: match.team_1.player_2?.id ===
																							  player?.id
																							? match.team_1.player_1?.id !==
																							  p.id
																							: match.team_2.player_1?.id ===
																							  player?.id
																							? match.team_2.player_2?.id !==
																							  p.id
																							: match.team_2.player_2?.id ===
																							  player?.id
																							? match.team_2.player_1?.id !==
																							  p.id
																							: false
																					)
																					.filter(
																						(match) =>
																							match.winner_team?.player_1_id ===
																								player?.id ||
																							match.winner_team?.player_2_id ===
																								player?.id
																					).length || 0) /
																				(matches
																					.filter(
																						(match) =>
																							(match.team_1.player_1?.id ===
																								player?.id ||
																								match.team_1.player_2?.id ===
																									player?.id ||
																								match.team_2.player_1?.id ===
																									player?.id ||
																								match.team_2.player_2?.id ===
																									player?.id) &&
																							(match.team_1.player_1?.id ===
																								p.id ||
																								match.team_1.player_2?.id ===
																									p.id ||
																								match.team_2.player_1?.id ===
																									p.id ||
																								match.team_2.player_2?.id ===
																									p.id)
																					)
																					.filter((match) =>
																						match.team_1.player_1?.id ===
																						player?.id
																							? match.team_1.player_2?.id !==
																							  p.id
																							: match.team_1.player_2?.id ===
																							  player?.id
																							? match.team_1.player_1?.id !==
																							  p.id
																							: match.team_2.player_1?.id ===
																							  player?.id
																							? match.team_2.player_2?.id !==
																							  p.id
																							: match.team_2.player_2?.id ===
																							  player?.id
																							? match.team_2.player_1?.id !==
																							  p.id
																							: false
																					).length || 0)
																			).toFixed(2) * 100
																	  ).toFixed(0)}
																%
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Partidos jugados en singles
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{
																	matches
																		.filter(
																			(match) =>
																				match.category === "singles" &&
																				(match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id) &&
																				(match.team_1.player_1?.id === p.id ||
																					match.team_1.player_2?.id === p.id ||
																					match.team_2.player_1?.id === p.id ||
																					match.team_2.player_2?.id === p.id)
																		)
																		.filter((match) =>
																			match.team_1.player_1?.id === player?.id
																				? match.team_1.player_2?.id !== p.id
																				: match.team_1.player_2?.id ===
																				  player?.id
																				? match.team_1.player_1?.id !== p.id
																				: match.team_2.player_1?.id ===
																				  player?.id
																				? match.team_2.player_2?.id !== p.id
																				: match.team_2.player_2?.id ===
																				  player?.id
																				? match.team_2.player_1?.id !== p.id
																				: false
																		).length
																}
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Partidos ganados en singles
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{
																	matches
																		.filter(
																			(match) =>
																				match.category === "singles" &&
																				(match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id) &&
																				(match.team_1.player_1?.id === p.id ||
																					match.team_1.player_2?.id === p.id ||
																					match.team_2.player_1?.id === p.id ||
																					match.team_2.player_2?.id === p.id)
																		)
																		.filter((match) =>
																			match.team_1.player_1?.id === player?.id
																				? match.team_1.player_2?.id !== p.id
																				: match.team_1.player_2?.id ===
																				  player?.id
																				? match.team_1.player_1?.id !== p.id
																				: match.team_2.player_1?.id ===
																				  player?.id
																				? match.team_2.player_2?.id !== p.id
																				: match.team_2.player_2?.id ===
																				  player?.id
																				? match.team_2.player_1?.id !== p.id
																				: false
																		)
																		.filter(
																			(match) =>
																				match.winner_team?.player_1_id ===
																					player?.id ||
																				match.winner_team?.player_2_id ===
																					player?.id
																		).length
																}
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Partidos perdidos en singles
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{
																	matches
																		.filter(
																			(match) =>
																				match.category === "singles" &&
																				(match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id) &&
																				(match.team_1.player_1?.id === p.id ||
																					match.team_1.player_2?.id === p.id ||
																					match.team_2.player_1?.id === p.id ||
																					match.team_2.player_2?.id === p.id)
																		)
																		.filter((match) =>
																			match.team_1.player_1?.id === player?.id
																				? match.team_1.player_2?.id !== p.id
																				: match.team_1.player_2?.id ===
																				  player?.id
																				? match.team_1.player_1?.id !== p.id
																				: match.team_2.player_1?.id ===
																				  player?.id
																				? match.team_2.player_2?.id !== p.id
																				: match.team_2.player_2?.id ===
																				  player?.id
																				? match.team_2.player_1?.id !== p.id
																				: false
																		)
																		.filter(
																			(match) =>
																				match.winner_team?.player_1_id !==
																					player?.id &&
																				match.winner_team?.player_2_id !==
																					player?.id
																		).length
																}
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Efectividad de partidos en singles
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{isNaN(
																	(
																		(
																			(matches
																				.filter(
																					(match) =>
																						match.category === "singles" &&
																						(match.team_1.player_1?.id ===
																							player?.id ||
																							match.team_1.player_2?.id ===
																								player?.id ||
																							match.team_2.player_1?.id ===
																								player?.id ||
																							match.team_2.player_2?.id ===
																								player?.id) &&
																						(match.team_1.player_1?.id ===
																							p.id ||
																							match.team_1.player_2?.id ===
																								p.id ||
																							match.team_2.player_1?.id ===
																								p.id ||
																							match.team_2.player_2?.id ===
																								p.id)
																				)
																				.filter((match) =>
																					match.team_1.player_1?.id ===
																					player?.id
																						? match.team_1.player_2?.id !== p.id
																						: match.team_1.player_2?.id ===
																						  player?.id
																						? match.team_1.player_1?.id !== p.id
																						: match.team_2.player_1?.id ===
																						  player?.id
																						? match.team_2.player_2?.id !== p.id
																						: match.team_2.player_2?.id ===
																						  player?.id
																						? match.team_2.player_1?.id !== p.id
																						: false
																				)
																				.filter(
																					(match) =>
																						match.winner_team?.player_1_id ===
																							player?.id ||
																						match.winner_team?.player_2_id ===
																							player?.id
																				).length || 0) /
																			(matches
																				.filter(
																					(match) =>
																						match.category === "singles" &&
																						(match.team_1.player_1?.id ===
																							player?.id ||
																							match.team_1.player_2?.id ===
																								player?.id ||
																							match.team_2.player_1?.id ===
																								player?.id ||
																							match.team_2.player_2?.id ===
																								player?.id) &&
																						(match.team_1.player_1?.id ===
																							p.id ||
																							match.team_1.player_2?.id ===
																								p.id ||
																							match.team_2.player_1?.id ===
																								p.id ||
																							match.team_2.player_2?.id ===
																								p.id)
																				)
																				.filter((match) =>
																					match.team_1.player_1?.id ===
																					player?.id
																						? match.team_1.player_2?.id !== p.id
																						: match.team_1.player_2?.id ===
																						  player?.id
																						? match.team_1.player_1?.id !== p.id
																						: match.team_2.player_1?.id ===
																						  player?.id
																						? match.team_2.player_2?.id !== p.id
																						: match.team_2.player_2?.id ===
																						  player?.id
																						? match.team_2.player_1?.id !== p.id
																						: false
																				).length || 0)
																		).toFixed(2) * 100
																	).toFixed(0)
																)
																	? 0
																	: (
																			(
																				(matches
																					.filter(
																						(match) =>
																							match.category === "singles" &&
																							(match.team_1.player_1?.id ===
																								player?.id ||
																								match.team_1.player_2?.id ===
																									player?.id ||
																								match.team_2.player_1?.id ===
																									player?.id ||
																								match.team_2.player_2?.id ===
																									player?.id) &&
																							(match.team_1.player_1?.id ===
																								p.id ||
																								match.team_1.player_2?.id ===
																									p.id ||
																								match.team_2.player_1?.id ===
																									p.id ||
																								match.team_2.player_2?.id ===
																									p.id)
																					)
																					.filter((match) =>
																						match.team_1.player_1?.id ===
																						player?.id
																							? match.team_1.player_2?.id !==
																							  p.id
																							: match.team_1.player_2?.id ===
																							  player?.id
																							? match.team_1.player_1?.id !==
																							  p.id
																							: match.team_2.player_1?.id ===
																							  player?.id
																							? match.team_2.player_2?.id !==
																							  p.id
																							: match.team_2.player_2?.id ===
																							  player?.id
																							? match.team_2.player_1?.id !==
																							  p.id
																							: false
																					)
																					.filter(
																						(match) =>
																							match.winner_team?.player_1_id ===
																								player?.id ||
																							match.winner_team?.player_2_id ===
																								player?.id
																					).length || 0) /
																				(matches
																					.filter(
																						(match) =>
																							match.category === "singles" &&
																							(match.team_1.player_1?.id ===
																								player?.id ||
																								match.team_1.player_2?.id ===
																									player?.id ||
																								match.team_2.player_1?.id ===
																									player?.id ||
																								match.team_2.player_2?.id ===
																									player?.id) &&
																							(match.team_1.player_1?.id ===
																								p.id ||
																								match.team_1.player_2?.id ===
																									p.id ||
																								match.team_2.player_1?.id ===
																									p.id ||
																								match.team_2.player_2?.id ===
																									p.id)
																					)
																					.filter((match) =>
																						match.team_1.player_1?.id ===
																						player?.id
																							? match.team_1.player_2?.id !==
																							  p.id
																							: match.team_1.player_2?.id ===
																							  player?.id
																							? match.team_1.player_1?.id !==
																							  p.id
																							: match.team_2.player_1?.id ===
																							  player?.id
																							? match.team_2.player_2?.id !==
																							  p.id
																							: match.team_2.player_2?.id ===
																							  player?.id
																							? match.team_2.player_1?.id !==
																							  p.id
																							: false
																					).length || 0)
																			).toFixed(2) * 100
																	  ).toFixed(0)}
																%
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Partidos jugados en dobles
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{
																	matches
																		.filter(
																			(match) =>
																				match.category === "doubles" &&
																				(match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id) &&
																				(match.team_1.player_1?.id === p.id ||
																					match.team_1.player_2?.id === p.id ||
																					match.team_2.player_1?.id === p.id ||
																					match.team_2.player_2?.id === p.id)
																		)
																		.filter((match) =>
																			match.team_1.player_1?.id === player?.id
																				? match.team_1.player_2?.id !== p.id
																				: match.team_1.player_2?.id ===
																				  player?.id
																				? match.team_1.player_1?.id !== p.id
																				: match.team_2.player_1?.id ===
																				  player?.id
																				? match.team_2.player_2?.id !== p.id
																				: match.team_2.player_2?.id ===
																				  player?.id
																				? match.team_2.player_1?.id !== p.id
																				: false
																		).length
																}
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Partidos ganados en dobles
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{
																	matches
																		.filter(
																			(match) =>
																				match.category === "doubles" &&
																				(match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id) &&
																				(match.team_1.player_1?.id === p.id ||
																					match.team_1.player_2?.id === p.id ||
																					match.team_2.player_1?.id === p.id ||
																					match.team_2.player_2?.id === p.id)
																		)
																		.filter((match) =>
																			match.team_1.player_1?.id === player?.id
																				? match.team_1.player_2?.id !== p.id
																				: match.team_1.player_2?.id ===
																				  player?.id
																				? match.team_1.player_1?.id !== p.id
																				: match.team_2.player_1?.id ===
																				  player?.id
																				? match.team_2.player_2?.id !== p.id
																				: match.team_2.player_2?.id ===
																				  player?.id
																				? match.team_2.player_1?.id !== p.id
																				: false
																		)
																		.filter(
																			(match) =>
																				match.winner_team?.player_1_id ===
																					player?.id ||
																				match.winner_team?.player_2_id ===
																					player?.id
																		).length
																}
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Partidos perdidos en dobles
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{
																	matches
																		.filter(
																			(match) =>
																				match.category === "doubles" &&
																				(match.team_1.player_1?.id ===
																					player?.id ||
																					match.team_1.player_2?.id ===
																						player?.id ||
																					match.team_2.player_1?.id ===
																						player?.id ||
																					match.team_2.player_2?.id ===
																						player?.id) &&
																				(match.team_1.player_1?.id === p.id ||
																					match.team_1.player_2?.id === p.id ||
																					match.team_2.player_1?.id === p.id ||
																					match.team_2.player_2?.id === p.id)
																		)
																		.filter((match) =>
																			match.team_1.player_1?.id === player?.id
																				? match.team_1.player_2?.id !== p.id
																				: match.team_1.player_2?.id ===
																				  player?.id
																				? match.team_1.player_1?.id !== p.id
																				: match.team_2.player_1?.id ===
																				  player?.id
																				? match.team_2.player_2?.id !== p.id
																				: match.team_2.player_2?.id ===
																				  player?.id
																				? match.team_2.player_1?.id !== p.id
																				: false
																		)
																		.filter(
																			(match) =>
																				match.winner_team?.player_1_id !==
																					player?.id &&
																				match.winner_team?.player_2_id !==
																					player?.id
																		).length
																}
															</p>
														</div>
														<div
															className={`flex flex-row items-center justify-between w-full`}
														>
															<p
																className={`text-${theme}-primaryColor text-lg max-lg:text-sm mt-2`}
															>
																Efectividad de partidos en dobles
															</p>
															<p
																className={`text-${theme}-primaryColor text-lg font-gothamBold max-lg:text-sm mt-2`}
															>
																{isNaN(
																	(
																		(
																			(matches
																				.filter(
																					(match) =>
																						match.category === "doubles" &&
																						(match.team_1.player_1?.id ===
																							player?.id ||
																							match.team_1.player_2?.id ===
																								player?.id ||
																							match.team_2.player_1?.id ===
																								player?.id ||
																							match.team_2.player_2?.id ===
																								player?.id) &&
																						(match.team_1.player_1?.id ===
																							p.id ||
																							match.team_1.player_2?.id ===
																								p.id ||
																							match.team_2.player_1?.id ===
																								p.id ||
																							match.team_2.player_2?.id ===
																								p.id)
																				)
																				.filter((match) =>
																					match.team_1.player_1?.id ===
																					player?.id
																						? match.team_1.player_2?.id !== p.id
																						: match.team_1.player_2?.id ===
																						  player?.id
																						? match.team_1.player_1?.id !== p.id
																						: match.team_2.player_1?.id ===
																						  player?.id
																						? match.team_2.player_2?.id !== p.id
																						: match.team_2.player_2?.id ===
																						  player?.id
																						? match.team_2.player_1?.id !== p.id
																						: false
																				)
																				.filter(
																					(match) =>
																						match.winner_team?.player_1_id ===
																							player?.id ||
																						match.winner_team?.player_2_id ===
																							player?.id
																				).length || 0) /
																			(matches
																				.filter(
																					(match) =>
																						match.category === "doubles" &&
																						(match.team_1.player_1?.id ===
																							player?.id ||
																							match.team_1.player_2?.id ===
																								player?.id ||
																							match.team_2.player_1?.id ===
																								player?.id ||
																							match.team_2.player_2?.id ===
																								player?.id) &&
																						(match.team_1.player_1?.id ===
																							p.id ||
																							match.team_1.player_2?.id ===
																								p.id ||
																							match.team_2.player_1?.id ===
																								p.id ||
																							match.team_2.player_2?.id ===
																								p.id)
																				)
																				.filter((match) =>
																					match.team_1.player_1?.id ===
																					player?.id
																						? match.team_1.player_2?.id !== p.id
																						: match.team_1.player_2?.id ===
																						  player?.id
																						? match.team_1.player_1?.id !== p.id
																						: match.team_2.player_1?.id ===
																						  player?.id
																						? match.team_2.player_2?.id !== p.id
																						: match.team_2.player_2?.id ===
																						  player?.id
																						? match.team_2.player_1?.id !== p.id
																						: false
																				).length || 0)
																		).toFixed(2) * 100
																	).toFixed(0)
																)
																	? 0
																	: (
																			(
																				(matches
																					.filter(
																						(match) =>
																							match.category === "doubles" &&
																							(match.team_1.player_1?.id ===
																								player?.id ||
																								match.team_1.player_2?.id ===
																									player?.id ||
																								match.team_2.player_1?.id ===
																									player?.id ||
																								match.team_2.player_2?.id ===
																									player?.id) &&
																							(match.team_1.player_1?.id ===
																								p.id ||
																								match.team_1.player_2?.id ===
																									p.id ||
																								match.team_2.player_1?.id ===
																									p.id ||
																								match.team_2.player_2?.id ===
																									p.id)
																					)
																					.filter((match) =>
																						match.team_1.player_1?.id ===
																						player?.id
																							? match.team_1.player_2?.id !==
																							  p.id
																							: match.team_1.player_2?.id ===
																							  player?.id
																							? match.team_1.player_1?.id !==
																							  p.id
																							: match.team_2.player_1?.id ===
																							  player?.id
																							? match.team_2.player_2?.id !==
																							  p.id
																							: match.team_2.player_2?.id ===
																							  player?.id
																							? match.team_2.player_1?.id !==
																							  p.id
																							: false
																					)
																					.filter(
																						(match) =>
																							match.winner_team?.player_1_id ===
																								player?.id ||
																							match.winner_team?.player_2_id ===
																								player?.id
																					).length || 0) /
																				(matches
																					.filter(
																						(match) =>
																							match.category === "doubles" &&
																							(match.team_1.player_1?.id ===
																								player?.id ||
																								match.team_1.player_2?.id ===
																									player?.id ||
																								match.team_2.player_1?.id ===
																									player?.id ||
																								match.team_2.player_2?.id ===
																									player?.id) &&
																							(match.team_1.player_1?.id ===
																								p.id ||
																								match.team_1.player_2?.id ===
																									p.id ||
																								match.team_2.player_1?.id ===
																									p.id ||
																								match.team_2.player_2?.id ===
																									p.id)
																					)
																					.filter((match) =>
																						match.team_1.player_1?.id ===
																						player?.id
																							? match.team_1.player_2?.id !==
																							  p.id
																							: match.team_1.player_2?.id ===
																							  player?.id
																							? match.team_1.player_1?.id !==
																							  p.id
																							: match.team_2.player_1?.id ===
																							  player?.id
																							? match.team_2.player_2?.id !==
																							  p.id
																							: match.team_2.player_2?.id ===
																							  player?.id
																							? match.team_2.player_1?.id !==
																							  p.id
																							: false
																					).length || 0)
																			).toFixed(2) * 100
																	  ).toFixed(0)}
																%
															</p>
														</div>
													</div>
												);
											})}
									</div>
								)}
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
